// extracted by css-extract-rspack-plugin
export default {"desktopInstructionsText":"BranchNextStepDesktop-module__desktopInstructionsText__StB6_6v"};